import { Content, Stripe } from "./loading-location-modal.styles";
import { ReactComponent as RwLogo } from '../../../assets/logo-rw-small.svg';
import { Modal } from "@mui/material";

type LoadingLocationModalProps = {
  open: boolean;
  locationName?: string | null;
};

export const LoadingLocationModal = ({ open, locationName }: LoadingLocationModalProps) => (
    <Modal open={open}>
      <Content>
        <RwLogo />
        <div>
          <h3>Loading...</h3>
          <h2>{locationName}</h2>
        </div>
        <Stripe />
      </Content>
    </Modal>
  )
